import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/local-tokens';
import { Icon } from '../Icon';

export const MenuCardButton = styled.button<{
    collapsed?: boolean;
}>`
    display: flex;
    gap: ${getToken(TokenName.SPACING_150)}px;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    width: 100%;
    border: none;
    background: none;
    cursor: pointer;
    box-sizing: border-box;
    text-align: left;
    margin: ${getToken(TokenName.SPACING_0)};
    padding: ${getToken(TokenName.SPACING_200)}px
        ${({ collapsed, theme }) =>
            collapsed
                ? `${getToken(TokenName.SPACING_200)({ theme })}px`
                : `${getToken(TokenName.SPACING_400)({ theme })}px`};
`;

export const MenuCardText = styled.div`
    flex: 1;
`;

export const MenuCardTitle = styled.div`
    ${getTextTokenPreset('BODY_M_STRONG')};
    color: ${getToken(TokenName.TEXT_STATIC_PRIMARY)};
`;

export const MenuCardSubtitle = styled.div`
    ${getTextTokenPreset('BODY_S')};
    color: ${getToken(TokenName.TEXT_STATIC_TERTIARY)};
`;

export const MenuCardIcon = styled(Icon)<{ active?: boolean }>`
    transform: ${({ active }) => (active ? 'rotate(180deg)' : 'none')};
    transform-origin: center center;
    transition-timing-function: ${ANIMATION_CURVE.default};
    transition-duration: ${ANIMATION_DURATION.fast}ms;
    transition-property: transform;
`;
